import { useMutation } from '@tanstack/vue-query';

type GenerateSalesOfferResponse = {
  success: true;
  data: {
    dealId: string;
    offerUrl: string;
    priceHoldExpiresAt: string;
    reused?: boolean;
  };
};

export const useGenerateSalesOffer = () => {
  const authStore = useAuthStore();

  return useMutation({
    mutationFn: ({
      propertyId,
      unitId,
      clientName,
      hideDeveloper,
    }: {
      propertyId: string;
      unitId: string;
      clientName?: string;
      hideDeveloper?: boolean;
    }) =>
      $fetch<GenerateSalesOfferResponse>(`/api/properties/${propertyId}/units/${unitId}/sales-offer`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${authStore.token}` },
        body: { clientName: clientName || undefined, hideDeveloper: hideDeveloper || undefined },
      }),
    onError: (error) => useErrorHandler().catchErrors(error),
  });
};

export default useGenerateSalesOffer;
